import { render } from "./CButtonRemove.vue?vue&type=template&id=6a090e47&scoped=true"
const script = {}

import "./CButtonRemove.vue?vue&type=style&index=0&id=6a090e47&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a090e47"]])

export default __exports__